/* global gsap -- layout/theme.liquid で CDN から読み込むライブラリ */
window.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  const panel = document.querySelector('.section-header .header-wrapper');
  if (!header || !panel) return;

  // ---- 共通設定（まとめて定義） ----
  const DUR = 0.7;
  const EASE = 'power2.out';
  const baseTween = (props) =>
    gsap.to(panel, { duration: DUR, ease: EASE, overwrite: 'auto', ...props });

  // SP/PCで閉じ高さを出し分け（<750px をSPとする）
  const mql = window.matchMedia('(max-width: 749px)');
  const closedHeight = () => (mql.matches ? 64 : 76);

  const GAP_SP = 20;
  const GAP_PC = 26;
  // 開いたときの高さ（実測pxで安定）
  const openHeight = () => {
    const h = Math.max(window.innerHeight, document.documentElement.clientHeight);
    const gap = mql.matches ? GAP_SP : GAP_PC;
    return Math.max(0, h - gap);
  };

  // 初期（閉じ）
  gsap.set(panel, { height: closedHeight() });

  // 開く/閉じる
  function openMenu() {
    gsap.killTweensOf(panel);
    baseTween({ height: openHeight() });
  }
  function closeMenu() {
    gsap.killTweensOf(panel);
    if (panel.scrollTop) gsap.set(panel, { scrollTop: 0 }); // チラつき防止
    baseTween({ height: closedHeight() });
  }

  // .menu-open の付け外しで開閉
  const mo = new MutationObserver(() => {
    header.classList.contains('menu-open') ? openMenu() : closeMenu();
  });
  mo.observe(header, { attributes: true, attributeFilter: ['class'] });

  // リサイズ時：開いていれば目標値追随、閉じていれば閉じ高さを更新
  const onResize = () => {
    if (header.classList.contains('menu-open')) {
      gsap.to(panel, { height: openHeight(), duration: 0.2, ease: 'none', overwrite: 'auto' });
    } else {
      gsap.set(panel, { height: closedHeight() });
    }
  };
  window.addEventListener('resize', onResize);
  mql.addEventListener?.('change', onResize);

  // 追記分

  // ハッシュ(#id)へスムースに移動。scroll-margin-top が効くので余白調整はCSSに任せる
  const smoothScrollToHash = (hash) => {
    if (!hash) return;
    const id = hash.replace(/^#/, '');
    const el = document.getElementById(id);
    if (!el) return;

    // ネイティブのスムーススクロール。scroll-margin-top が尊重される
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // #リンククリックをフック（同一ページのみ自前制御）
  const onAnchorClick = (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;

    const url = new URL(a.getAttribute('href'), location.href);

    // 別ページへの遷移はそのまま（/pages/xxx#id などは遷移先で処理）
    if (url.pathname !== location.pathname || !url.hash) return;

    // 同一ページの #だけ横取り
    e.preventDefault();

    const go = () => smoothScrollToHash(url.hash);

    // メニューが開いていたら先に閉じてからスクロール
    if (header.classList.contains('menu-open')) {
      header.classList.remove('menu-open'); // MutationObserver → closeMenu() が走る
      // 閉じアニメの時間（DUR）だけ待ってからスクロール
      gsap.delayedCall(DUR, go);
    } else {
      go();
    }
  };

  document.addEventListener('click', onAnchorClick, { passive: false });
});

document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('.header-wrapper.is-top-page');
  if (!panel) return;

  const el = document.querySelector('.header-wrapper');

  const update = () => {
    if (window.scrollY > 0) el.classList.remove('is-top-page');
    else el.classList.add('is-top-page');
  };

  update(); // 初期状態を反映
  window.addEventListener('scroll', update, { passive: true });
});
